/**
 * HERA-9198: visibility rules for the Company Settings "Payroll Provider" menu group.
 *
 * Parent ("Payroll Provider"): the tenant has both feature flags on, and the user either has Full
 * Access or has not had the module permission explicitly turned off. Full Access always passes
 * (Full Access users are often created without the dedicated permission on core Hera write paths).
 *
 * Sync sub-items ("Associate Sync Results", "Sync History"): the parent rule plus the tenant sync
 * switch (tenant permissionPayrollProvider === true), the same rule as the Athena sync routes.
 */
export function isPayrollProviderMenuVisible(tenantFeaturePermissions, userInfo) {
  if (!tenantFeaturePermissions || !userInfo) return false
  if (tenantFeaturePermissions.featureAccessPayrollProvider !== true) return false
  if (tenantFeaturePermissions.featureEnabledPayrollProvider !== true) return false
  return userInfo.permissionFullAccess === true || userInfo.permissionPayrollProvider !== false
}

export function isPayrollSyncMenuVisible(tenantFeaturePermissions, userInfo) {
  return (
    isPayrollProviderMenuVisible(tenantFeaturePermissions, userInfo) &&
    tenantFeaturePermissions.permissionPayrollProvider === true
  )
}

/**
 * HERA-9207: visibility of the PAYROLL_PROVIDER_MATCHES_FOUND toggle in notification preferences.
 * Matches the recipient rule: Full Access users, or users with permissionPayrollProvider explicitly true.
 * A null/undefined module permission does not count.
 */
export function isPayrollProviderPreferenceVisible(tenantFeaturePermissions, userInfo) {
  const permissions = tenantFeaturePermissions || {}
  return (
    !!permissions.featureAccessPayrollProvider &&
    !!permissions.featureEnabledPayrollProvider &&
    (userInfo?.permissionFullAccess === true || userInfo?.permissionPayrollProvider === true)
  )
}
